import React from "react"

import { colors } from "@/styles/colors"
import { makeStyles } from "@material-ui/core"
import { themeColors } from "letalkui"

const useStyles = makeStyles(({
	titleText: {
		fontSize: "24px",
		fontWeight: 600,
		color: colors.gray[600]
	},
	emptyState: {
		padding: "48px 24px",
		textAlign: "center" as React.CSSProperties["textAlign"],
		color: themeColors.colors.system.gray[500]
	},
	search: {
		height: 50,
		minWidth: 320,
		"& .MuiOutlinedInput-root": {
			height: 50,
			"& input": {
				padding: "8px 14px"
			}
		}
	},
	searchButton: {
		height: 50
	},
	viewToggleGroup: {
		display: "flex",
		background: themeColors.colors.system.gray[100],
		borderRadius: "10px",
		padding: "4px"
	},
	viewToggleTabActive: {
		display: "flex",
		alignItems: "center",
		gap: "6px",
		padding: "8px 16px",
		borderRadius: "8px",
		fontSize: "13px",
		fontWeight: 700,
		cursor: "pointer",
		background: themeColors.colors.system.gray[0],
		color: themeColors.colors.system.gray[800],
		boxShadow: "0 1px 3px rgba(74, 74, 74, 0.08)",
		transition: "all 0.15s"
	},
	viewToggleTabInactive: {
		display: "flex",
		alignItems: "center",
		gap: "6px",
		padding: "8px 16px",
		borderRadius: "8px",
		fontSize: "13px",
		fontWeight: 700,
		cursor: "pointer",
		background: "transparent",
		color: themeColors.colors.system.gray[500],
		boxShadow: "none",
		transition: "all 0.15s"
	}
}))

export default useStyles
